import axios from "axios";
import { tmsApi } from "../api";

export const vendorIdToLocalStorage = (aggregatorCompanyName, tableData) =>
  {
    tableData.forEach((vendorValue) => {
      if(vendorValue.companyName === aggregatorCompanyName)
      {
        localStorage.setItem('vendorId', vendorValue.id);
      }
    })
  }
  
export const getParentCompany = async () => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .get(
          tmsApi +
            `v1/entities/aggregatoralllist`,
          
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  export const getVendorsList = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .get(
          tmsApi +
            `v1/entities/aggregatorlist/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`,
          
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  export const getVendor = async (id) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .get(
          tmsApi +
            `v1/entities/aggregator/id/${id}`,
          
          config
        )
        // .then((resp) => {
        //   console.log(resp, "response");
        //   return resp;
        // });
    } catch (error) {
      console.log("error", error);
    }
  };

  export const getvendorsFilter = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(tmsApi + `v1/entities/aggregator/filter`,obj, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

export const getVendorTripTableFilterData = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/aggregator/trip/filter`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getVendorTripTableSearchData = async (searchData, body, serviceCityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/entities/aggregator/trip/search/${serviceCityId}?search=${searchData}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getTripsForVendor = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi +
          `v1/entities/aggregator/trip`,
        obj,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
  
  export const getVendorsSearch = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .get(tmsApi + `v1/entities/aggregator/search/${obj.serviceCityId}?mobile=${obj.searchData} `, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  export const DeleteVendor = async (id) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .put(tmsApi + `v1/entities/aggregator/delete/${id}`, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  export const CreateVendorPost = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(tmsApi + `v1/entities/aggregator/create `, obj, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  export const UpdateVendorPost = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .put(tmsApi + `v1/entities/aggregator/update`, obj, config) 
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  export const getVendorBooking = async (obj) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
  
    try {
      return axios
        .post(tmsApi + `v1/entities/aggregator/booking`, obj, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  export const getVendorBookingTableSearchData = async (obj) => {
    const body = obj.obj;
  
    const config = {
      headers: {
        token: localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
      },
    };
  
    try {
      return axios
        .post(
          tmsApi +
            `v1/entities/aggregator/booking/search/${body.serviceCityId}?search=${body.custMobile}`,
          body,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  export const getVendorBookingTableFilterData = async (body) => {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
  
    try {
      return axios
        .post(tmsApi + `v1/entities/aggregator/booking/filter`, body.body, config)
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  export const cancelVendorBooking = (body) => {
    const config = {
      headers: {
        token: localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(tmsApi + "v1/entities/aggregator/booking/cancel", body, config)
        .then((resp) => {
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };
  
  // --------- Car current status based on vendor ID and service city -----------
  export const getCabAndDriverForVendor = (body) => {
    const config = {
      headers: {
        token: localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(tmsApi + "v1/entities/aggregator/carcurrentstatus", body, config)
        .then((resp) => {
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  // --------- Car current status based on vendor ID and service city with filter-----------
  export const getCabAndDriverForVendorWithFilter = (body) => {
    const config = {
      headers: {
        token: localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(tmsApi + "v1/entities/aggregator/carcurrentstatus/filter", body, config)
        .then((resp) => {
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

    // --------- Car current status based on vendor ID and service city with filter-----------
    export const getCabAndDriverForVendorWithSearchFilter = (paramValue) => {
      const config = {
        headers: {
          token: localStorage.getItem("token"),
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          search : paramValue,
        }
      };
      try {
        return axios
          .post(tmsApi + "v1/entities/aggregator/carcurrentstatus/filter", config)
          .then((resp) => {
            return resp;
          });
      } catch (error) {
        console.log("error", error);
      }
    };

export const getAssignDriverListForVendorAssigned = async (obj) => {
  console.log(obj, "objiss");
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    if (obj.pickupType == "AirportToCity" && obj.driverType == "Active") {
      return axios
        .get(
          tmsApi +
          `v1/entities/aggregator/findairportdriver/${obj.vendorId}/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (
      (obj.pickupType == "CityToAirport" || obj.pickupType == "CityToCity") &&
      obj.driverType == "Active"
    ) {
      return axios
        .get(
          tmsApi +
          `v1/entities/aggregator/finddriver/${obj.vendorId}/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (obj.driverType == "OnTrip") {
      return axios
        .get(
          tmsApi +
          `v1/entities/aggregator/findontripdriver/${obj.vendorId}/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    } else if (obj.driverType == "Inactive") {
      return axios
        .get(
          tmsApi +
          `v1/entities/aggregator/findlogoutdriver/${obj.vendorId}/${obj.bookingId}`,
          config
        )
        .then((resp) => {
          console.log(resp, "response");
          return resp;
        });
    }
  } catch (error) {
    console.log("error", error);
  }
};